import CA from './CA';

export default CA;
